<template>
  <div class="container-fluid">
    <div class="row pt-4">
     <div class="col-8">
      <p class="page-title"><i class="fas fa-box"></i> Products</p>
     </div>
     <div class="col-4">
        <div class="input-group md-form form-sm form-2 pl-0 table-filter">
          <input  class="col" name="query" v-model="searchQuery" placeholder="Search">
          <div class="input-group-append">
            <span class="input-group-text"><i class="fas fa-filter text-grey" aria-hidden="true"></i></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <marketplaces-grid
          :data="gridData"
          :columns="gridColumns"
          :filter-key="searchQuery"
        />
        <b-pagination
          size="sm"
          v-model="page"
          :per-page="100"
          :total-rows="totalRows"
          align="center"
          @change="changePage($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BPagination } from 'bootstrap-vue';
import {GridTable} from '@dmunoz/gridtable';
import ProductsApiRequest from '@/components/ApiRequester/Product.js';
const productsApiRequest = new ProductsApiRequest();
export default {
  name: 'Products',
  components: {
    'marketplaces-grid': GridTable,
    'b-pagination': BPagination,
  },
    data() {
    return {
      updatedId:0,
      startDate: "",
      endDate: "",
      searchQuery: '',
      totalRows: 0,
      page: 1,
      logTextArea: '',
      noteModal: false,
      gridData: [],
      gridColumns: [
        {
          column: 'SKU', index: 'SKU', type: 'link', path: '/products/:ID/:Marketplace',
        },
        {
          column: 'Product', index: 'Product', type: 'raw',
        },
        {
          column: 'Marketplace', index: 'Marketplace', type: 'raw',
        },
      ],

    };
  },
  mounted() {
      document.getElementById('loader').classList.add('active');
       productsApiRequest.getProducts({page: this.page}).then((response) => {
         this.gridData = response.data.data;
         this.totalRows = response.data.total;
         document.getElementById('loader').classList.remove('active');
       }).catch(() => {
         document.getElementById('loader').classList.remove('active');
       });
       productsApiRequest.finishCall();
  },
  watch: {
    searchQuery(newV) {
      document.getElementById('loader').classList.add('active');
      const payload = {};
      payload.search_key = newV;
      productsApiRequest.cancelPreviousRequest();
      productsApiRequest.getProducts({page: this.page, sku: payload.search_key}).then((response) => {
         this.gridData = response.data.data;
         this.totalRows = response.data.total;
         productsApiRequest.finishCall();
         document.getElementById('loader').classList.remove('active');
       }).catch(() => {
         document.getElementById('loader').classList.remove('active');
       });
    },
  },
  methods: {
    calculateDays(lastUnitDays){
      const todayString = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      const endDate = new Date(todayString);
      endDate.setDate(endDate.getDate()+3);
      const startDate = endDate;
      this.endDate = endDate.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });

      startDate.setDate(endDate.getDate() - lastUnitDays + 1 );
      this.startDate = startDate.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      this.endDate = this.formatDate(this.endDate);
      this.startDate = this.formatDate(this.startDate);
    },
    formatDate(date) {
      const today = new Date(date);
      let dd = today.getDate();
      let mm = today.getMonth() + 1; // January is 0!
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }
      if (mm < 10) {
        mm = `0${mm}`;
      }
      return `${yyyy}-${mm}-${dd}`;
    },
    getDaysFromMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    changePage(page){
      let payload = {};
      if(this.searchQuery !== ''){
        payload = {
          page,
          'sku': this.searchQuery
        }
      } else {
        payload = {
          page,
        }
      }
      document.getElementById('loader').classList.add('active');
      this.gridData = [];
      productsApiRequest.getProducts(payload).then((response) => {
          this.gridData = response.data.data,
          this.totalRows = response.data.total
          document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    }
  }
};
</script>
